import React from "react"
import { Link } from "gatsby"
import {
  LineChart,
  BarChart,
  Bar,
  Brush,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts"

const ChartFour = ({data}) => {
 
  //Length of data
  const leng = data.length

//Calculate max value in array, looping not an option

let maxOne = 0;

if (leng >=24) {
  maxOne = Math.max(data[leng-1].IAPrice,data[leng-2].IAPrice,data[leng-3].IAPrice,data[leng-4].IAPrice,
    data[leng-5].IAPrice,data[leng-6].IAPrice,data[leng-7].IAPrice,data[leng-8].IAPrice,data[leng-9].IAPrice,
    data[leng-10].IAPrice,data[leng-11].IAPrice,data[leng-12].IAPrice,data[leng-13].IAPrice,
    data[leng-14].IAPrice,data[leng-15].IAPrice,data[leng-16].IAPrice,data[leng-17].IAPrice,
    data[leng-18].IAPrice,data[leng-19].IAPrice,data[leng-20].IAPrice,data[leng-21].IAPrice,
    data[leng-22].IAPrice,data[leng-23].IAPrice)
} else if (leng >=10) {
  maxOne = Math.max(data[leng-1].IAPrice,data[leng-2].IAPrice,data[leng-3].IAPrice,data[leng-4].IAPrice,
    data[leng-5].IAPrice,data[leng-6].IAPrice,data[leng-7].IAPrice,data[leng-8].IAPrice,data[leng-9].IAPrice)
}

//Round the max value  
  const maxOneRou = Math.ceil(maxOne/100000)*100000

  return (
    <section>
      <div style={{margin:`0 auto 0 auto`}}>
        <h2>Inflation Adjusted Prices</h2> 
        <div class="centreMe">
        <p>Inflation adjusted prices have been calculated using the same method as the <Link to="https://www.bankofengland.co.uk/monetary-policy/inflation/inflation-calculator">Bank of England's inflation calculator</Link>.</p>
        </div>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={data} margin={{ top: 15, left: 20, right: 20 }} syncId="anyId">
          <Tooltip 
          formatter={time => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(time)}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="IAPrice"
            stroke="red"
            name="Inflation Adjusted Price"
            strokeWidth={3}
            dot={false}
            isAnimationActive={false}
          />
          <XAxis
            dataKey="Year"
          />
          <YAxis
            interval={0}
            domain={[0, maxOneRou]}
            tickFormatter={time => new Intl.NumberFormat('en-GB').format(time)}
          />
          <CartesianGrid stroke="none" />
        </LineChart>
        </ResponsiveContainer>
      </div>
         </section>
  )
}

export default ChartFour
